import { CustomRouteDetails, ActivityType } from '../types/CustomRoute';

export const stubbedCustomRouteDetails: CustomRouteDetails = {
  id: 1,
  bounds: { longitudeTopLeft: 0, latitudeTopLeft: 0, longitudeBottomRight: 0, latitudeBottomRight: 0 },
  activityType: ActivityType.Hiking,
  name: 'Map - February 26, 2025',
  slug: 'map-february-26-2025-13111c2',
  contentPrivacy: 'urn:alltrails:visibility:public',
  distance: 0,
  elevationGain: 0,
  segments: [],
  waypoints: [],
  location: {}
};
